<template>
  <div
    v-if="loyaltyOffers?.[0]?.offerRecords?.length && loyaltyOffers?.[0]?.eventType === 'GAMIFIED_BONUS'"
    id="gamified-offers-section"
  >
    <GamifiedOfferBanner
      :offers="JSON.stringify(loyaltyOffers)"
      :username="firstName"
      class="margin-bottom-m lh-container-custom-gutters"
    />
  </div>
  <div
    v-if="loyaltyOffers?.[0]?.errors?.error && !loyaltyOffers?.[0]?.offerRecords?.length"
    class="clearfix"
  >
    <Notification
      severity="error"
      aria-role="alert"
      :closable="false"
      class="lh-container-custom-gutters"
    >
      {{ loyaltyOffers?.[0]?.errors?.error?.[0]?.message }}
    </Notification>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import GamifiedOfferBanner from '../../shims/gamified-offers-banner/GamifiedOfferBanner.vue';
import Notification from '@nuxt-common/atomic-ui/app/components/notification/Notification.vue';
import { useLoyaltyHubStore } from '../../stores/useLoyaltyHubStore';

const loyaltyHub = useLoyaltyHubStore();
const unifiedLoyaltySummary = computed(() => loyaltyHub.unifiedLoyalty);
const firstName = computed(() => unifiedLoyaltySummary.value?.points?.loyaltyPointsResponse?.loyaltyInfo?.profile?.firstName);
const loyaltyOffers = computed(() => unifiedLoyaltySummary.value?.loyaltyOffers || []);
</script>


